import React, { useState } from 'react';
import Box from '@mui/material/Box';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { SideBarMenuItem } from 'app/store/types';
import BaseLeftSideBar from '../shared-components/BaseLeftSideBar/BaseLeftSideBar';
import { PATH_RELEASE_LIST } from 'app/utils/routes';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SystemAdminLeftSideBar = () => {
	const history = useHistory();
	const { t } = useTranslation();
	const menuItems: SideBarMenuItem[] = [
		{ label: t('releases'), icon: <CalendarMonthIcon />, value: 'releases', url: PATH_RELEASE_LIST }
	];

	const [selected, setSelected] = useState(menuItems[0].value);

	const handleSelectItem = (item: SideBarMenuItem) => {
		setSelected(item.value);
	};
	const handleClickNavigate = (item: SideBarMenuItem) => {
		if (item.url) {
			history.push(item.url);
		}
	};

	return (
		<Box>
			<BaseLeftSideBar
				menuItems={menuItems}
				selected={selected}
				onClickNavigate={handleClickNavigate}
				onSelect={handleSelectItem}
			/>
		</Box>
	);
};

export default SystemAdminLeftSideBar;
